import { GetterTree } from 'vuex'
import { RootState } from '@/app/providers/store/types/RootState'
import { ProductCarouselSchema, ProductImage } from '../types/product-carousel'

export const getters: GetterTree<ProductCarouselSchema, RootState> = {
	getCurrentImage(state): ProductImage | undefined {
		return state.images[state.currentImageIndex]
	}
}